import { normalizeStorageType } from '../utils/formatting';

export const INTERNAL_PAGE_TYPES = {
	CITY_LANDING_PAGE: 'cityLandingPage',
	AMENITY_LANDING_PAGE: 'amenityLandingPage',
	VEHICLE_LANDING_PAGE: 'vehicleLandingPage',
};

// All canonical types are lowercase
export const PPC_TYPE_TRAILER = 'trailer';
export const PPC_TYPE_BOAT = 'boat';
export const PPC_TYPE_CAR = 'car';
export const PPC_TYPE_RV = 'rv';
export const PPC_TYPE_STORAGE = 'self';

// Used in PaidTemplatePage & page actions
export const PaidLandingTypes = {
	self: PPC_TYPE_STORAGE,
	boat: PPC_TYPE_BOAT,
	car: PPC_TYPE_CAR,
	rv: PPC_TYPE_RV,
	trailer: PPC_TYPE_TRAILER,
};

// Helper to get canonical storage type
export function getCanonicalStorageType(type) {
	const normalized = normalizeStorageType(type);
	return PaidLandingTypes[normalized] || PPC_TYPE_STORAGE;
}

// Height of the sticky search toolbar (NewSearchToolbar), used as a negative scroll offset
// to prevent results from being obscured when scrolling into view.
export const STICKY_TOOLBAR_SCROLL_OFFSET = 138;

export const REVIEW_SECTION_COMMON_TITLE =
	'4.5 stars on TrustPilot with 76,000+ Reviews';
